import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type PageErrorStylesProps = {
  wrapper: SxProps
  header: SxProps
  content: SxProps
  contentElements: SxProps
  mainText: SxProps
  secundaryText: SxProps
  button: SxProps
  info: SxProps
  infoText: SxProps
  infoIcon: SxProps
  infoNumber: SxProps
  infoMail: SxProps
  infoWrapperNumber: SxProps
}

export const PageErrorStyles: PageErrorStylesProps = {
  wrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    zIndex: 9999,
    backgroundColor: 'white'
  },

  header: {
    height: 38,
    padding: theme.spacing(1.5, 3),
    boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',
    boxSizing: 'content-box'
  },

  content: {
    overflowY: 'auto'
  },

  contentElements: {
    minHeight: '100%',

    '& img': {
      padding: theme.spacing(1.75, 0),
      margin: theme.spacing(2.5, 0)
    }
  },

  mainText: {
    color: theme.colors.blue04,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '64px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '72px',
    padding: theme.spacing(2, 0),
    margin: theme.spacing(2.5, 0, 1, 0)
  },

  secundaryText: {
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '28px',
    margin: theme.spacing(1, 0, 2.5, 0)
  },

  button: {
    margin: theme.spacing(2.5, 0),
    padding: '11px 0',

    '& .MuiButton-root': {
      margin: 0
    }
  },

  info: {
    textAlign: 'center',
    margin: theme.spacing(2.5, 0),
    width: '425px',
    padding: '12px',
    borderRadius: '4px',
    backgroundColor: theme.colors.blue08
  },

  infoText: {
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '24px',
    marginBottom: '8px'
  },

  infoIcon: {
    fontSize: '22px',
    color: theme.colors.gray600,
    marginRight: '8px'
  },

  infoNumber: {
    textDecoration: 'none',
    margin: '0 4px',
    color: theme.colors.gray14
  },

  infoMail: {
    textDecoration: 'none',
    color: theme.colors.byzantineBlue200
  },

  infoWrapperNumber: {
    marginBottom: '6px'
  }
}
